import { ADVICEPREP_TRIAL_CONNECTIONS, advicePrepCommittedMonthly, formatAdvicePrepCurrency } from '../pricing'

type AdvicePrepTrialTermsProps = {
  trialMonths: number | null
  dueToday: number
  /** Already formatted for display, not an ISO instant. */
  trialEndLabel: string | null
  /** The coupon's own sentence, when it discounts rather than zeroes the fee. */
  discountSentence?: string | null
}

/**
 * The three figures a customer agrees to, rendered the same whether they are
 * read inline on the card or inside the promo modal. Shared so the two places a
 * code can be entered cannot describe the same coupon differently.
 */
export default function AdvicePrepTrialTerms({
  trialMonths,
  dueToday,
  trialEndLabel,
  discountSentence,
}: AdvicePrepTrialTermsProps) {
  return (
    <>
      <p className="mb-2">
        {trialMonths && trialEndLabel
          ? `Includes ${ADVICEPREP_TRIAL_CONNECTIONS} free platform connections. Nothing is charged until ${trialEndLabel}, when billing starts automatically.`
          : discountSentence || 'Your promo code will be applied to this subscription.'}
      </p>
      <div className="flex flex-wrap gap-x-8 gap-y-2">
        <Figure label="Due today" value={formatAdvicePrepCurrency(dueToday, 2)} />
        {trialMonths && trialEndLabel ? <Figure label="Trial ends" value={trialEndLabel} /> : null}
        <Figure
          label={trialMonths ? 'First charge' : 'Renews at'}
          value={formatAdvicePrepCurrency(advicePrepCommittedMonthly(), 2)}
        />
      </div>
      {/* Only ever rendered before subscribing, where the date is computed from
          the browser clock because Stripe has not issued a trial_end yet. The
          manage card quotes the server's own date and says nothing of the sort. */}
      {trialMonths && trialEndLabel ? (
        <p className="mb-0 mt-2 text-[11px] text-gray-500">
          Dates are estimated until your trial is confirmed.
        </p>
      ) : null}
    </>
  )
}

function Figure({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <div className="text-[11px] text-gray-500">{label}</div>
      <div className="font-display text-base font-bold text-gray-900">{value}</div>
    </div>
  )
}
